import React from 'react'
import { cx } from '@emotion/css'

import { SkeletonIcon, SkeletonText } from '@offerzen/pinata-shame'
import SkeletonSection from '../SkeletonSection'

import styles from './styles'

const SkeletonLocationPreferences = () => (
  <SkeletonSection className={styles.body}>
    <div className={styles.title}>
      <SkeletonIcon size="small" theme="dark" />
      <SkeletonText theme="dark" width={180} />
    </div>

    <For each="row" of={[0, 1]}>
      <ul className={cx(styles.list, styles.cities)} key={row}>
        <li>
          <SkeletonText theme="dark" width={180} />
        </li>
        <ul className={styles.list}>
          <li>
            <SkeletonText theme="dark" width={320} />
          </li>
        </ul>
      </ul>
    </For>
  </SkeletonSection>
)

export default SkeletonLocationPreferences
